export const fDate = (date) => {
    return new Date(date).toDateString()
}

export const fDateTime = (date) => {
    return new Date(date).toLocaleString()
}

export const getISOTimeWithTimeZoneBased = (date) => {
    const targetDate = new Date(date)
    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISOTime = (new Date(targetDate.getTime() - tzoffset)).toISOString();
    return localISOTime
}

// Should return - 'YYYY-MM-DD'
export const generateDateKey = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}

export const generateDatesKeys = (startDate, endDate) => {

    const diffDays = daysBetween(startDate, endDate)
    const acrossAmountOfDaysDays = diffDays > 30 ? 30 : diffDays // hard coded the campaigns to be no longer than a month

    const dateKeys = []
    for (let i = 0; i <= acrossAmountOfDaysDays; i++) {
        const date = new Date(startDate)
        date.setDate(date.getDate() + i)
        const key = generateDateKey(date)
        dateKeys.push(key)
    }

    return dateKeys
}

export const getNextWeekendRange = () => {
    const currentDate = new Date();
    const currentDay = currentDate.getDay(); // 0 is Sunday, 6 is Saturday

    // Calculate days until the next Friday and next Sunday, always moving to the next week if today is Friday, Saturday, or Sunday
    const daysUntilFriday = (12 - currentDay) % 7; // Next Friday (5 - currentDay + 7) % 7, and adjusted to ensure it's always the next week
    const daysUntilSunday = (14 - currentDay) % 7; // Next Sunday (7 - currentDay + 7) % 7, and adjusted similarly

    // Get next Friday and Sunday dates
    const nextFriday = new Date(currentDate);
    nextFriday.setDate(currentDate.getDate() + daysUntilFriday);

    const nextSunday = new Date(currentDate);
    nextSunday.setDate(currentDate.getDate() + daysUntilSunday);

    // Return dates as Date objects
    return {
        startDate: nextFriday,
        endDate: nextSunday
    };
}

export const getDayName = (date) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[date.getDay()]
}

export const getMonthName = (date) => {
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const monthIndex = date.getMonth()
    return monthNames[monthIndex]
}

export const formatTime = (date, hoursOnly) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert 24-hour format to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Add leading zero to hours and minutes if less than 10
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    if (hoursOnly) {
        return hours + '' + ampm;
    }

    return hours + ':' + minutes + ' ' + ampm;
}

// Outputs: "Aug 3, 2024 14"
export const formatDateTime = (dateToFormat) => {
    const date = new Date(dateToFormat)

    // Format the date
    const formattedDate = date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    })

    // Extract the hour
    const formattedHour = date.getHours();

    // Combine date and hour
    return `${formattedDate} ${formattedHour}`;
}

// e.g., "Dec 01 2024"
export const formatDate = (date) => {
    const options = { month: 'short', day: '2-digit', year: 'numeric' };
    return date.toLocaleDateString('en-US', options).replace(',', '');
}


export const daysBetween = (date1, date2) => {
    // If date2 is not provided, return 1
    if (!date2) {
        return 0
    }

    // Get the difference in time between the two dates in milliseconds
    const timeDifference = Math.abs(date2 - date1);
    // Convert the time difference from milliseconds to days
    const dayDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    return dayDifference;
}

export const daysSinceTimestamp = (timestamp) => {
    const givenDate = new Date(timestamp * 1000);

    // Get the current date and time
    const today = new Date();

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = today - givenDate;

    // Convert milliseconds to days
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const daysDifference = Math.floor(differenceInMilliseconds / millisecondsPerDay);

    return daysDifference;
}

export const daysBetweenTimestamps = (timestamp1, timestamp2) => {
    // Convert both UNIX timestamps to milliseconds
    const date1 = new Date(timestamp1 * 1000);
    const date2 = new Date(timestamp2 * 1000);

    // Calculate the absolute difference in milliseconds
    const differenceInMilliseconds = Math.abs(date2 - date1);

    // Convert milliseconds to days
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const daysDifference = Math.floor(differenceInMilliseconds / millisecondsPerDay);

    return daysDifference;
}

